export default __webpack_public_path__ + "static/media/logo_small.01859c1f.png";